import { Card, CardBody } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { CommonButtonsInterface } from "../../../Types/ButtonsType";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

export const CommonButtons: React.FC<CommonButtonsInterface> = ({ commonButtonsData, title, subTitle, className, raised }) => {
  return (
    <Card>
      <CommonCardHeader title={title} span={subTitle} tag />
      <CardBody>
        <div className="btn-showcase">
          {commonButtonsData.map((data, index) => (
            <Btn key={index} className={`${className ? className : ""} ${raised && `btn-air-${data.color}`}`} outline={data.outline} active={data.active} disabled={data.disabled} size={data.size ? data.size : ""} id={data.id} color={data.color}>
              {data.title}
            </Btn>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};
